export class GTMEvent {
  event = 'GTMevent';
  eventCategory: string;
  eventAction: string;
  eventLabel: string;
  userId: string;
}

